import React from 'react';
import { Row, Col } from 'react-bootstrap';

const PurchaseOrderLineAdditionalHeader = ({ poData }) => {
  return (
    <>
      <Row className="mt-3 mb-3">
        <Col>
          {/*<p className="text-secondary mb-1 fs-11">*/}
          {/*  Type the first 2 characters of the name or item SKU of PO items in*/}
          {/*  the order-item dropdown and fill the rest of the details.*/}
          {/*</p>*/}

          <p className="text-secondary mb-0 fs-11">
            You can import the list of PO items by clicking the 'Import Excel'
            button.
          </p>
        </Col>
      </Row>

      <Row>
        <Col>
          <div className="d-flex align-items-center flex-wrap gap-3">
            <h5 className="text-nowrap fs-9 mb-0">
              Reserved Quantity: {poData?.total_quantity || 0}
            </h5>

            <h5 className="text-nowrap fs-9 mb-0">
              Reserved Weight: {poData?.total_weight?.value || 0}
              {poData?.total_weight?.unit && `${poData?.total_weight?.unit}`}
            </h5>

            <h5 className="text-nowrap fs-9 mb-0">
              Total Amount (INR): {poData?.total_gross || 0}
            </h5>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default PurchaseOrderLineAdditionalHeader;
